module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/campaigns/campaigns.component.css
// module id = ./src/app/components/campaigns/campaigns.component.css
// module chunks = main